import { render, staticRenderFns } from "./DragModal.vue?vue&type=template&id=caeca882&scoped=true"
import script from "./DragModal.vue?vue&type=script&lang=js"
export * from "./DragModal.vue?vue&type=script&lang=js"
import style0 from "./DragModal.vue?vue&type=style&index=0&id=caeca882&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caeca882",
  null
  
)

export default component.exports